import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentforgrouptravelpune() {



const cardData =
{
  keyword: 'Bus on Rent for Group Travel Pune',
  heading: 'Sanavi Travels: Bus on Rent for Group Travel Pune',
  headingDescription: 'Sanavi Travels offers dependable Bus on Rent for Group Travel in Pune, ideal for families, corporate teams, wedding groups, picnic outings, school trips, and outstation journeys. With AC and Non-AC buses, professional drivers, flexible pickup points, and transparent pricing, we ensure smooth, safe, and well-coordinated group transportation across Pune and nearby destinations.',

  top: 'Top Travel Uses & Group Travel Highlights in Pune',

  "topPlaces": [
    {
      "title": "Family Group Travel in Pune",
      "description": "Family group travel in Pune becomes convenient and stress-free with bus rentals that allow everyone to travel together in one vehicle. Buses provide ample seating, luggage space, and a comfortable environment for elders and children, eliminating the need for multiple cars and ensuring better coordination throughout the journey."
    },
    {
      "title": "Corporate Group Travel & Team Outings",
      "description": "Corporate teams often require punctual, organized, and professional transport for meetings, conferences, off-sites, and team outings. Group bus rentals in Pune ensure employees travel together on schedule, reducing logistical issues while maintaining comfort, safety, and a professional travel experience."
    },
    {
      "title": "Wedding & Ceremony Group Transport",
      "description": "Weddings involve transporting large groups of guests between venues, hotels, and event locations. Hiring a bus for group travel ensures timely arrivals, organized movement of guests, and a relaxed experience without parking or coordination hassles."
    },
    {
      "title": "Picnic & Leisure Group Trips",
      "description": "Group picnics and leisure outings from Pune are more enjoyable when everyone travels together. Bus rentals provide a relaxed atmosphere, allow social interaction during travel, and ensure safe transportation to picnic spots, resorts, and tourist locations."
    },
    {
      "title": "Outstation Group Tours from Pune",
      "description": "For outstation group tours to destinations like Mahabaleshwar, Lonavala, Shirdi, or Bhimashankar, buses offer comfortable long-distance travel with proper seating, luggage handling, and experienced drivers familiar with highways and ghat routes."
    },
    {
      "title": "School & College Group Travel",
      "description": "Educational institutions rely on group buses for excursions, competitions, and study tours. Bus rentals ensure student safety, disciplined travel, and smooth supervision by staff members."
    },
    {
      "title": "Religious & Pilgrimage Group Travel",
      "description": "Religious groups traveling to temples and pilgrimage sites prefer buses for collective travel, allowing devotional unity, timely darshan, and reduced travel fatigue."
    },
    {
      "title": "Large Social & Community Groups",
      "description": "Community events, social gatherings, and society outings require reliable group transport. Bus rentals simplify planning and ensure everyone reaches the destination together."
    }
  ],

  "services": [
    {
      "name": "Bus on Rent for Group Travel Pune",
      "description": "Sanavi Travels provides specialized bus rental services for group travel in Pune, designed to handle diverse group sizes and travel purposes. Whether it is a family outing, corporate event, wedding function, or long-distance tour, our buses ensure coordinated group movement, reduced travel stress, and a smooth overall journey. This service focuses on comfort, punctuality, safety, and hassle-free logistics for group travelers."
    },
    {
      "name": "AC Bus for Group Pune",
      "description": "AC buses for group travel offer climate-controlled comfort, making them ideal for summer travel and long journeys. These buses help passengers remain relaxed and refreshed, especially during extended travel hours."
    },
    {
      "name": "Non AC Bus for Group Pune",
      "description": "Non-AC buses provide an economical yet comfortable option for group travel, suitable for short trips, budget-friendly outings, and large groups looking for reliable transport without premium features."
    },
    {
      "name": "Luxury Bus Hire for Group Pune",
      "description": "Luxury buses are perfect for premium group travel such as weddings, VIP movements, and corporate events. With plush interiors, pushback seating, and enhanced ride quality, they elevate the overall travel experience."
    },
    {
      "name": "Mini Bus for Group Travel Pune",
      "description": "Mini buses are ideal for small to medium-sized groups, offering flexibility, easy maneuverability within city limits, and comfortable seating for short and medium-distance travel."
    },
    {
      "name": "32 Seater Bus for Group Travel Pune",
      "description": "32 seater buses are suitable for medium to large groups, providing balanced seating capacity, sufficient luggage space, and comfortable long-distance travel options."
    },
    {
      "name": "35 Seater Bus for Group Travel Pune",
      "description": "35 seater buses support large group movements, ensuring everyone travels together comfortably for weddings, corporate trips, and outstation tours."
    },
    {
      "name": "Bus Hire for Family Group Pune",
      "description": "Family group bus services ensure safe and coordinated travel for all age groups, allowing families to focus on enjoyment rather than travel logistics."
    },
    {
      "name": "Bus Hire for Corporate Group Pune",
      "description": "Corporate group bus rentals support office travel, employee outings, conferences, and training programs with professional drivers and punctual service."
    },
    {
      "name": "Affordable Bus Rental for Group Pune",
      "description": "Affordable group bus packages offer transparent pricing and dependable service, making group travel cost-effective without compromising comfort or safety."
    },
    {
      "name": "Best Bus Service for Group Pune",
      "description": "Sanavi Travels is trusted as one of the best bus service providers for group travel in Pune, known for reliability and consistent quality."
    },
    {
      "name": "Bus with Driver for Group Pune",
      "description": "All group bus rentals include trained drivers experienced in city routes, highways, and outstation travel, ensuring safe and timely journeys."
    },
    {
      "name": "Bus for Wedding Group Pune",
      "description": "Wedding group buses ensure organized guest transport between venues, hotels, and ceremonies, adding convenience and punctuality to celebrations."
    },
    {
      "name": "Bus for Picnic Group Pune",
      "description": "Picnic group buses support relaxed and enjoyable travel to resorts, parks, and tourist destinations around Pune."
    },
    {
      "name": "Bus for Outstation Group Pune",
      "description": "Outstation group bus services are ideal for long-distance travel, offering comfort, safety, and smooth coordination for extended journeys."
    }
  ],

  "tableData": [
    ["Group Travel Bus", "AC Bus"],
    ["Non AC Bus", "Luxury Bus"],
    ["Mini Bus", "32 Seater Bus"],
    ["35 Seater Bus", "Outstation Bus"],
    ["Wedding Group", "Corporate Group"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Comfortable Group Travel", "WhyChoosedescription": "Buses ensure everyone travels together comfortably." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Professional drivers manage city and highway routes efficiently." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, 32 seater, 35 seater, AC, Non-AC, and luxury buses available." },
    { "WhyChooseheading": "Clean & Maintained Fleet", "WhyChoosedescription": "All buses are regularly cleaned and serviced." },
    { "WhyChooseheading": "Flexible Pickup Locations", "WhyChoosedescription": "Pickup points can be customized across Pune." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing with no hidden charges." },
    { "WhyChooseheading": "Ideal for All Group Types", "WhyChoosedescription": "Suitable for families, corporates, weddings, and tours." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for reliable group transport services." }
  ]
};

const faqData = [
  { question: 'Do you provide buses for group travel in Pune?', answer: 'Yes, Sanavi Travels offers bus rental services for group travel in Pune.' },
  { question: 'Are AC buses available for group travel?', answer: 'Yes, both AC and Non-AC buses are available.' },
  { question: 'What seating capacities do you offer?', answer: 'Mini buses, 32 seater, and 35 seater buses are available.' },
  { question: 'Is a driver included in the rental?', answer: 'Yes, all rentals include experienced drivers.' },
  { question: 'Do you offer buses for weddings and corporate events?', answer: 'Yes, group buses are available for weddings, corporate events, and outings.' },
  { question: 'Can we book buses for outstation group travel?', answer: 'Yes, outstation group travel is supported.' },
  { question: 'Are buses sanitized before trips?', answer: 'Yes, all buses are cleaned and sanitized regularly.' },
  { question: 'Can pickup locations be customized?', answer: 'Yes, pickup points can be customized as per group needs.' },
  { question: 'Is group travel cost-effective with buses?', answer: 'Yes, group bus travel reduces overall transportation costs.' },
  { question: 'How do I book a group travel bus in Pune?', answer: 'You can book through our website or by contacting customer support.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'Excellent bus service for our group trip in Pune. Very comfortable and well-managed.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Joshi',
    feedback: 'Sanavi Travels handled our corporate group travel perfectly. Highly reliable service.',
    rating: 5
  }
];







































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent for Group Travel Pune - Sanavi Travels",
  "description": "Sanavi Travels offers buses on rent in Pune for group travel, including family groups, corporate groups, weddings, picnics, and outstation trips. AC and Non-AC buses, mini buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent for Group Travel Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses on rent in Pune for group travel with Sanavi Travels. AC & Non-AC mini buses, 32-seater and 35-seater buses for family groups, corporate groups, weddings, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/272.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentforgrouptravelpune;